import { render, staticRenderFns } from "./EduPlatform.vue?vue&type=template&id=1ffeb008"
import script from "./EduPlatform.vue?vue&type=script&lang=js"
export * from "./EduPlatform.vue?vue&type=script&lang=js"
import style0 from "./EduPlatform.vue?vue&type=style&index=0&id=1ffeb008&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports